/* eslint-disable import/prefer-default-export */
import phone from '../assets/phone.jpeg';
import phoneCase from '../assets/case.jpeg';

export const mockProducts = [
  {
    title: 'iPhone',
    desc: 'The new iPhone!',
    price: '123.213',
    image: phone,
    id: 1,
  },
  {
    title: 'Phone case',
    desc: 'Phone case for your iPhone',
    price: '312',
    image: phoneCase,
    id: 2,
  },
];
